import gql from 'graphql-tag';

export const createDevicesMutation = gql`
  mutation ($input: DevicesCreateInput) {
    createDevices(input: $input)
    {
      iBeacons {
        deviceId
      }
      eddystones {
        deviceId
      }
      readers {
        deviceId
      }
      bluetoothHubs {
        deviceId
      }
      gateways {
        deviceId
      }
    }
  }
`
